import React, { useRef, useState, useCallback } from 'react';
import { Wrapper } from './components/Wrapper';
import { ViewMoreButton } from './components/ViewMoreButton';
import { Suggestions } from './components/Suggestions';
import { SuggestionsPillsProvider } from './context/SuggestionsPillsContext';

export const SuggestionsPills = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    const containerRef = useRef<HTMLDivElement>(null);
    const overflowRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLDivElement>(null);

    return (
        <Wrapper
            containerRef={containerRef}
            overflowRef={overflowRef}
            isOpen={isOpen}
        >
            <SuggestionsPillsProvider
                containerRef={containerRef}
                overflowRef={overflowRef}
                buttonRef={buttonRef}
            >
                <Suggestions />
                <ViewMoreButton
                    buttonRef={buttonRef}
                    isSuggestionsPillsOpen={isOpen}
                    toggle={toggle}
                />
            </SuggestionsPillsProvider>
        </Wrapper>
    );
};

SuggestionsPills.displayName = 'Filters.SuggestionsPills';
